import genTheme from '../utils/genTheme'

const genVar = genTheme('icon')

export const iconTheme = {
  fill: genVar('fill'),
}
